import { a } from './chunk-5HWZQ4DE.js';
import * as e from '@radix-ui/react-toggle-group';
import * as i from 'react';
import { jsx } from 'react/jsx-runtime';

var g=i.forwardRef(({className:o,...r},t)=>jsx(e.Item,{className:a("border border-gray-300 px-4 py-2 font-medium text-gray-900 text-sm data-[state=on]:z-50 max-md:w-[25px] hover:border data-[state=on]:border-primary hover:border-gray-400 data-[state=on]:bg-primary hover:bg-primary max-md:px-0.5 data-[state=on]:text-white hover:text-white hover:opacity-70 data-[state=on]:shadow-[0_0_0_1px] data-[state=on]:shadow-primary",o),...r,ref:t}));g.displayName=e.Item.displayName;var m=i.forwardRef(({className:o,...r},t)=>jsx(e.Root,{className:a("inline-flex",o),...r,ref:t}));m.displayName=e.Root.displayName;

export { g as a, m as b };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-7VUQRHH6.js.map